import React, { Component } from "react";
import UsersForm from "../UsersForm/UsersForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Social_BenefitsPage
Description : Componente que contienen el formulario de la pantalla Social_Benefits 
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente Social_BenefitsForm
================================================================================ */

class UserPage extends Component{
    render(){
        return(
            <div>                    
                <UsersForm/>
            </div>
        )   
    }
}

export default UserPage;